import React from "react";
import { SEO, MainLayout, BusinessCustomer } from "../../../components";

const BusinessCustomerPage = () => {
  return (
    <>
      <SEO title="Business Customer" />
      <MainLayout>
        <BusinessCustomer />
      </MainLayout>
    </>
  );
};

export default BusinessCustomerPage;
